import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { GrundstueckListEntryMeta } from '../../../core/av-api';

@Pipe({
  name: 'orderBySdrGrundstueckNummer'
})
export class OrderBySdrGrundstueckNummerPipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array: GrundstueckListEntryMeta[], ascending = true): GrundstueckListEntryMeta[] {
    if (ascending) {
      return Array.from(array).sort((a: GrundstueckListEntryMeta, b: GrundstueckListEntryMeta) => this.orderByComparator(a, b));
    } else {
      return Array.from(array).sort((a: GrundstueckListEntryMeta, b: GrundstueckListEntryMeta) => this.orderByComparator(b, a));
    }
  }

  private orderByComparator(a: GrundstueckListEntryMeta, b: GrundstueckListEntryMeta): number {
    return this.comperatorService.propertyComparator('nummer')(a.grundstueckNummer, b.grundstueckNummer);
  }
}
